import { MouseEvent } from 'react';
import { ArrowDownward, ArrowUpward, SwapVert } from '@mui/icons-material';
import { styled, useTheme } from '@mui/material/styles';
import { SortDirection } from 'common/types/summaryDefinitions';

interface SortIndicatorProps {
  title: string;
  direction: SortDirection | null;
  onClick: () => void;
}

const Root = styled('span')({
  alignItems: 'center',
  cursor: 'pointer',
  display: 'inline-flex',
  gap: 2,
  userSelect: 'none',
  '&:hover .sort-hint': {
    opacity: 0.6,
  },
});

const SortIndicator = ({ title, direction, onClick }: SortIndicatorProps) => {
  const theme = useTheme();
  const isActive = direction !== null;

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    onClick();
  };

  const activeIconStyle = { fill: theme.palette.primary.main, fontSize: '18px' } as const;
  const hintIconSx = { fontSize: 14, opacity: 0.25, transition: 'opacity 0.15s' } as const;

  return (
    <Root onClick={handleClick}>
      <span style={{ fontWeight: isActive ? 'bold' : 'inherit' }}>{title}</span>
      {direction === 'asc' && <ArrowUpward style={activeIconStyle} />}
      {direction === 'desc' && <ArrowDownward style={activeIconStyle} />}
      {!isActive && <SwapVert className="sort-hint" sx={hintIconSx} />}
    </Root>
  );
};

export default SortIndicator;
